import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import { EventData } from "../../models/EventData";
import moment from "moment";
import MatchOddsTable from "../../components/MatchOddsTable/MatchOddsTable";
import BMTable from "../../components/BMTable/BMTable";
import Betslip from "../../components/BetSlip/BetSlip";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { BsData } from "../../models/BsData";
import { UserBet } from "../../models/UserBet";
import OpenBets from "../../components/OpenBets/OpenBets";
import FancyTable from "../../components/FancyTable/FancyTable";
import cricket from "../../assets/images/sports/cricket.svg";
import tennis from "../../assets/images/sports/tennis.svg";
import soccer from "../../assets/images/sports/soccer.svg";
import inpalyImg from "../../assets/images/sports/inplay.svg";
import { useParams } from "react-router-dom";
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Card,
  Box,
  Tab,
  bottomNavigationClasses,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
// import Script from "next/script";
import axios from "axios";
import { removeExchangeBet } from "../../store";
import {
  isDreamWsConnected,
  subscribeDreamWsForMatchOdds,
  subscribeWsForEventOdds,
  unsubscribeAllWsforEvents,
  subscribeWsForBookmakerMarkets,
  subscribeWsForFancyMarkets,
} from "../../websockets/websocket";
import LiveStream from "../../components/LiveStream/LiveSteam";
import "./AllMarketsPage.scss";

type StoreProps = {
  eventInfo: EventData;
  bets: BsData[];
  openBetsData: UserBet[];
  removeExchangeBet: (index: number) => void;
};

export const AllMarketsPage: React.FC<StoreProps> = (props) => {
  const { eventInfo, bets, openBetsData, removeExchangeBet } = props;

  const [openBetSlip, setOpenBetSlip] = useState<boolean>(false);
  const [openStream, setOpenStream] = useState<boolean>(false);

  const [openBets, setOpenBets] = useState<boolean>(true);
  let [marketData, setMarketData] = useState<EventData>();
  const [liveStream, setLiveStream] = useState<boolean>(false);
  const [value, setValue] = React.useState("4");
  const [scorecardID, setScorecardID] = useState<string>("");

  const loadSportRadar = () => {
  if (!scorecardID) return;

  const old = document.getElementById("sr-widget-script");
  if (old) old.remove();

  const script = document.createElement("script");
  script.id = "sr-widget-script";

  script.innerHTML = `
(function(a,b,c,d,e,f,g,h,i){
a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},
i.l=1*new Date,
i.o=f,
g=b.createElement(c),
h=b.getElementsByTagName(c)[0],
g.async=1,
g.src=d,
g.setAttribute("n",e),
h.parentNode.insertBefore(g,h))
})(window,document,"script",
"https://ws-cdn001.akamaized.net/8ee45b574e2781d581b0b0a133803906/widgetloader",
"SIR",
{
theme:false,
language:"en"
});

SIR("addWidget",".sr-widget-1","match.lmtPlus",{
layout:"double",
scoreboard:"extended",
momentum:"extended",
collapseTo:"momentum",
matchId:${scorecardID}
});
`;

  document.body.appendChild(script);
};

  const { sportId } = useParams();

  useEffect(() => {
    let matchOdds = [];
    console.log("sportId", sportId);
    if (sportId === "1" && eventInfo) {
      if (eventInfo?.markets?.matchOdds?.length) {
        let a = eventInfo.markets.matchOdds
          ? eventInfo.markets.matchOdds.filter(
              (item) => item.marketName === "Match Odds"
            )[0]
          : null;
        if (a) matchOdds.push(a);
        let b = eventInfo.markets.matchOdds
          ? eventInfo.markets.matchOdds.filter(
              (item) => item.marketName === "Over/Under 0.5 Goals"
            )[0]
          : null;
        if (b) matchOdds.push(b);
        let c = eventInfo.markets.matchOdds
          ? eventInfo.markets.matchOdds.filter(
              (item) => item.marketName === "Over/Under 1.5 Goals"
            )[0]
          : null;
        if (c) matchOdds.push(c);
        let d = eventInfo.markets.matchOdds
          ? eventInfo.markets.matchOdds.filter(
              (item) => item.marketName === "Over/Under 2.5 Goals"
            )[0]
          : null;
        if (d) matchOdds.push(d);
        let e = eventInfo.markets.matchOdds
          ? eventInfo.markets.matchOdds.filter(
              (item) => item.marketName === "Over/Under 2.5 Goals"
            )[0]
          : null;
        if (e) matchOdds.push(e);

        let f = eventInfo.markets.matchOdds
          ? eventInfo.markets.matchOdds.filter(
              (item) => item.marketName === "Winner 2022"
            )[0]
          : null;
        if (e) matchOdds.push(e);
        setMarketData({
          ...eventInfo,
          markets: { ...eventInfo.markets, matchOdds },
        });
      }
    } else setMarketData(eventInfo);
  }, [eventInfo]);

  useEffect(() => {
    if (!openBetSlip && bets?.length > 0) {
      setOpenBetSlip(true);
    }
  }, [bets]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    // console.log("All markets");
    if (eventInfo?.eventId && eventInfo?.eventId !== "") {
      if (eventInfo.markets.matchOdds.length > 0) {
        for (let mo of eventInfo.markets.matchOdds) {
          subscribeDreamWsForMatchOdds(
            eventInfo.providerName,
            eventInfo.eventId,
            mo.marketId
          );
        }
      }

      if (
        eventInfo.markets?.bookmakers &&
        eventInfo.markets?.bookmakers?.length > 0
      ) {
        for (let bm of eventInfo.markets.bookmakers) {
          subscribeWsForBookmakerMarkets(eventInfo.eventId, bm.marketId);
        }
      }

      if (
        eventInfo.markets.fancyMarkets &&
        eventInfo.markets.fancyMarkets.length > 0
      ) {
        subscribeWsForFancyMarkets(eventInfo.eventId);
      }
    }

    return () => {
      unsubscribeAllWsforEvents();
      removeExchangeBet(0);
      setMarketData(null);
    };
  }, [isDreamWsConnected(), eventInfo?.eventId, eventInfo?.providerName]);

  useEffect(() => {
    setScorecardID("");
    if (eventInfo?.eventId) {
      axios
        .get(
          `https://lt-fn-cdn001.akamaized.net/techablesoftware/en/Etc:UTC/gismo/match_info/m` +
            eventInfo?.eventId
        )
        .then((result) => {
          var MatchId = result.data.queryUrl;
          var str = MatchId;
          let matches = str.split("/");
          setScorecardID(matches[1]);
        });
    }

    useEffect(() => {
        if (scorecardID) {
            loadSportRadar();
        }
    }, [scorecardID]);

    return () => {
      setScorecardID("");
    };
  }, [eventInfo, value]);


  return (
    <div className="market-ctn">
      <div className="left-side-ctn">
        <Card className="event-heading">
          <Typography gutterBottom component="div" className="event-name">
            {marketData && marketData.eventName && marketData.eventName
              ? marketData.eventName
              : "!!! NO Event !!!"}
            {/* {marketData && marketData.competitionName} */}
          </Typography>

          <Typography gutterBottom component="div" className="date">
            {marketData &&
              marketData.openDate &&
              moment(marketData.openDate).format("MMM DD YYYY hh:mm A")}
          </Typography>
        </Card>

        {marketData && marketData.markets ? (
          <Box className="mob-view">
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  className="teb-list"
                >
                  <Tab label="Score" value="3" className="tabs" />
                  <Tab label="Live Stream" value="4" className="tabs" />
                  <Tab label="Open Bets" value="2" className="tabs" />
                </TabList>
              </Box>

              <TabPanel value="2">
                <OpenBets openBets={openBetsData} provider={"Dream"} />
              </TabPanel>
              <TabPanel value="3">
                {" "}
                <div className="widgets">
                  <div>
                    <div className="sr-widget sr-widget-1"></div>
                  </div>
                </div>
              </TabPanel>

              <TabPanel value="4">
                {" "}
                <Accordion
                  expanded={liveStream}
                  onChange={() => setLiveStream(!liveStream)}
                  className="right-side-accordion"
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className="right-side-accordion-summary"
                    style={{
                      backgroundColor: "var(--primary)",
                      maxHeight: "15px",
                      minHeight: "44px",
                    }}
                  >
                    <Typography sx={{ flexShrink: 0 }}>Live Stream</Typography>
                  </AccordionSummary>
                  <AccordionDetails className="accordion-detail-section">
                    <LiveStream eventID={eventInfo?.eventId} />
                  </AccordionDetails>
                </Accordion>
              </TabPanel>
            </TabContext>
          </Box>
        ) : null}
        <Card className="web-view">
          <div className="widgets">
            <div>
              <div className="sr-widget sr-widget-1"></div>
            </div>
          </div>
        </Card>
        <div className="">
          <div>
            {marketData &&
            marketData.markets &&
            marketData.markets?.matchOdds &&
            marketData.markets?.matchOdds?.length ? (
              <MatchOddsTable />
            ) : null}
          </div>

          <div>
            {marketData &&
            marketData.markets &&
            marketData.markets?.bookmakers &&
            marketData.markets?.bookmakers?.length ? (
              <BMTable />
            ) : null}
          </div>

          <div>
            {marketData &&
            marketData.markets &&
            marketData.markets?.fancyMarkets &&
            marketData.markets?.fancyMarkets?.length ? (
              <FancyTable />
            ) : null}
          </div>
        </div>
      </div>

      <div className="right-side-ctn">
        <div className="content-ctn">
          {/* <Accordion
            expanded={openStream}
            onChange={() => setOpenStream(!openStream)}
            className="right-side-accordion live-stream-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              className="right-side-accordion-summary"
            >
              <Typography sx={{ flexShrink: 0 }}>Live Stream</Typography>
            </AccordionSummary>
            <AccordionDetails className="accordion-detail-section">
              <LiveStream eventID={eventInfo?.eventId} />
            </AccordionDetails>
          </Accordion> */}

          <Accordion
            expanded={liveStream}
            onChange={() => setLiveStream(!liveStream)}
            className="right-side-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              className="right-side-accordion-summary"
            >
              <Typography sx={{ flexShrink: 0 }}>Live Stream</Typography>
            </AccordionSummary>
            <AccordionDetails className="accordion-detail-section">
              <LiveStream eventID={eventInfo?.eventId} />
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={openBetSlip && bets && bets.length > 0}
            // onChange={() => setOpenBetSlip(!openBetSlip)}
            onChange={(_, expanded) => setOpenBetSlip(!openBetSlip)}
            className="right-side-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="betslip-header"
              className="right-side-accordion-summary"
            >
              <Typography sx={{ flexShrink: 0 }}>
                BET SLIP ({bets && bets.length})
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="accordion-detail-section">
              <Betslip page={"dream"} />
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={openBets}
            onChange={() => setOpenBets(!openBets)}
            className="right-side-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              className="right-side-accordion-summary"
            >
              <Typography sx={{ flexShrink: 0 }}>
                Open Bets ({openBetsData?.length})
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="accordion-detail-section">
              <OpenBets openBets={openBetsData} provider={"Dream"} />
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    operatorId: state.auth.operatorId,
    loggedIn: state.auth.loggedIn,
    bets: state.betslip.bets,
    openBetsData: state.betslip.openBets,
    eventInfo: state.sportsBook.eventInfo,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AllMarketsPage);
